var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusDueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14ZM7.53668 3.52434C7.26039 3.03435 6.63148 2.85421 6.13707 3.12838C5.96621 3.21846 5.82806 3.35861 5.73718 3.5211L3.07611 8.14357C2.86162 8.66202 3.1161 9.2601 3.64322 9.47267C3.74865 9.5123 3.86134 9.53788 3.97404 9.54473H9.29619C9.56884 9.53031 9.81968 9.41142 10.0051 9.21002C10.1905 9.0079 10.285 8.74525 10.2705 8.47504C10.2632 8.35938 10.2377 8.24805 10.1796 8.11115L7.53668 3.52434ZM6.3152 7.77968C6.3152 7.60638 6.46062 7.46227 6.63511 7.46227C6.80961 7.46227 6.95139 7.60314 6.95139 7.77572C6.95139 7.95226 6.80961 8.09674 6.63511 8.09674C6.46062 8.09674 6.3152 7.95226 6.3152 7.77968ZM6.3152 5.52789C6.3152 5.35459 6.46062 5.21444 6.63511 5.21444C6.80961 5.21444 6.95139 5.35459 6.95139 5.52789V6.54714C6.95139 6.72008 6.80961 6.86455 6.63511 6.86455C6.46062 6.86455 6.3152 6.72008 6.3152 6.54714V5.52789Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDueIcon);
export default __webpack_public_path__ + "static/media/status-due-icon.0f6330fae0832c02c817dbdcbc618c9e.svg";
export { ForwardRef as ReactComponent };